const SERVIZIO_FRONTOFFICE = 'frontoffice'

const STATO_PAGAMENTO_VERBALE = {
  PAGABILE: 'PAGABILE',
  NON_PAGABILE: 'NON_PAGABILE',
  PAGATO: 'PAGATO',
  NESSUN_VERBALE: 'NESSUN_VERBALE',
}

function isPagamentoPagato(pagamento) {
  const { pending, descrizione } = pagamento
  return pending || descrizione.toLowerCase().includes('pagamento effettuato da') // Manca flag pagato che connet dovrà tornare in futuro
}

function calcolaStatoPagamentoVerbale(verbale) {
  if(!verbale) return STATO_PAGAMENTO_VERBALE.NESSUN_VERBALE
  const { pagamenti } = verbale
  if (pagamenti.some(isPagamentoPagato)) return STATO_PAGAMENTO_VERBALE.PAGATO
  if (pagamenti.some(({ pagabile }) => pagabile)) return STATO_PAGAMENTO_VERBALE.PAGABILE
  return STATO_PAGAMENTO_VERBALE.NON_PAGABILE
}

export {
  SERVIZIO_FRONTOFFICE,
  STATO_PAGAMENTO_VERBALE,
  isPagamentoPagato,
  calcolaStatoPagamentoVerbale,
}